import React, { useState, useEffect } from "react";
import { useTheme } from "../../../components/ThemeSwitcher/ThemeSwitcher";
import { useTranslation } from "react-i18next";
import { createPortal } from "react-dom";
import { showAlert } from "../../../utils/Helpers";
import "../AnimalApprovedRecords.css";
import { Button } from "react-bootstrap";
import { FiEdit2, FiEye } from "react-icons/fi";
import { FaEye, FaPlus } from "react-icons/fa";
import { RxCalendar } from "react-icons/rx";
import { HiMiniEllipsisVertical } from "react-icons/hi2";
import { BiArrowBack } from "react-icons/bi";
import Select from "react-select";
import CustomDropdownIndicator from "../../../components/common/CustomDropdownIndicator";
import "react-tooltip/dist/react-tooltip.css";
import "../AnimalSightingMobile/AnimalSightingMobile.css";

let editingRows = [];
var sketchVM = null;
var sketch = null;
const AnimalSightingMobileApproved = ({
  data,
  activeApprovedtabs,
  setActiveApprovedtab,
  GetFamilyDropdown,
  GetSpeciesDropdown,
  // t,
  // i18n ,
  DropdownFamilyValues,
  DropdownSpeciesValues,
  domainValues,
  commonProps,
  IsDataModified,
  fileUpload,
  handleDelete,
  onClose,
  fullView,
  ...props
}) => {
  const { mapview, showForm, setShowForm, sptledit, setSptlEdit } = props;
  const [invertebratesData, setInvertebratesData] = useState(null);
  const [plantsData, setPlantsData] = useState(null);
  const [mammalData, setMammalsData] = useState(null);
  const [reptilesData, setReptilesData] = useState(null);
  const [currentSelectedRow, setCurrentSelectedRow] = useState(null);
  const [currentClonedRow, setcurrentClonedRow] = useState(null);
  const [speciesOrder, setSpeciesOrder] = useState(null);
  const [speciesName, setSpeciesName] = useState(null);
  const [speciesFamily, setSpeciesFamily] = useState(null);
  const [widgetMobEl, setWidgetMobEl] = useState(null);
  const {
    formatToDatetimeLocal,
    handleInsectInputChange,
    handleRowSelectionForMobile,
    handleFieldClick,
    handleReplaceField,
    handleEditSelectedRows,
  } = commonProps;
  const [isEditingCompleted, setIsEditingCompleted] = useState(IsDataModified);
  const { theme } = useTheme();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (activeApprovedtabs.includes(t("Invertebrates")) || activeApprovedtabs.includes("Invertebrates")) {
      setInvertebratesData(data);
    } else if (activeApprovedtabs.includes(t("Plants")) || activeApprovedtabs.includes("Plants")) {
      setPlantsData(data);
    } else if (activeApprovedtabs.includes(t("Mammals")) || activeApprovedtabs.includes("Mammals")) {
      setMammalsData(data);
    } else if (activeApprovedtabs.includes(t("Reptiles")) || activeApprovedtabs.includes("Reptiles")) {
      setReptilesData(data);
    }
  }, [data, activeApprovedtabs, i18n.language, t]);
  useEffect(() => {
    setActiveApprovedtab(t(activeApprovedtabs))
  }, [i18n.language, t])
  // const animalData = [
  //   {
  //     id: 1,
  //     title: "Odonta (Dragon Flies)",
  //     family: "Libellulidae",
  //     species: "Crocothemis Erythraea",
  //     tag: "Natural",
  //     location: "UAE",
  //     habitat: "Coastal",
  //     date: "24/03/2024",
  //   },
  //   {
  //     id: 2,
  //     title: "Psocoptera (Psocids)",
  //     family: "Troglidae",
  //     species: "Lepinotus Reticulatus",
  //     tag: "Protected Areas",
  //     location: "UAE",
  //     habitat: "Forest",
  //     date: "12/05/2024",
  //   },
  // ];

  const [editingCardId, setEditingCardId] = useState(null);
  const [previewCardId, setPreviewCardId] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(null);
  useEffect(() => {
    setIsEditingCompleted(IsDataModified);
  }, [IsDataModified]);
  const toggleEdit = (id, action) => {
    if (action == "Edit") {
      setEditingCardId((prevId) => (prevId === id ? null : id));
    }
    else if (action == "Preview") {
      setPreviewCardId((prevId) => (prevId === id ? null : id));
    }
    else {
      setEditingCardId(false);
    }
    setIsDropdownOpen(null);
    setIsEditingCompleted(false);
    handleEditSelectedRows();
    var selectedRow = data.current.filter((feature) => {
      return feature.id == id;
    });
    setCurrentSelectedRow(selectedRow);
    setcurrentClonedRow(selectedRow[0]);
    // if (activeApprovedtabs.includes(t("Invertebrates")) || activeApprovedtabs.includes("Invertebrates")) {

    //   setSpeciesFamily(selectedRow[0].SpeciesFamily)
    //   GetFamilyDropdown(selectedRow[0].Species_Order);
    //   GetSpeciesDropdown(selectedRow[0].SpeciesFamily);
    // }
  };

  const toggleDropdown = (id) => {
    handleRowSelectionForMobile(id);
    setIsDropdownOpen((prevId) => (prevId === id ? null : id));
  };

  const handleEditDropdownChange = (selectedOption, key) => {
    //To set current selcted rows as in webapplication mode it gets reset the array of currentselected rows
    handleRowSelectionForMobile(currentClonedRow.id);
    DropdownSpeciesValues = [];
    var value;
    // Create a copy of the current cloned row
    editingRows = { ...currentClonedRow };

    // Update the cloned row in the state
    if (selectedOption && selectedOption.target) {
      value = selectedOption.target.value;
    } else if (selectedOption && selectedOption.value) {
      value = selectedOption.label;
    }

    if (activeApprovedtabs.includes(t("Invertebrates")) || activeApprovedtabs.includes("Invertebrates")) {
      if (key === "Species_Order") {
        setSpeciesOrder(value);
        setSpeciesFamily(null);
        setSpeciesName(null);
      } else if (key === "SpeciesFamily") {
        setSpeciesFamily(value);
      } else if (key === "SpeciesName") {
        setSpeciesName(value);
      }
    }

    editingRows[key] = selectedOption ? value : "";
    setcurrentClonedRow(editingRows);
    //handleInsectInputChange(selectedOption, key);
  };
  const handleEditSave = () => {
    // if (activeApprovedtabs.includes("Invertebrates")) {
    //   if (
    //     speciesFamily != null &&
    //     speciesName != null &&
    //     speciesOrder != nulls
    //   ) {
    //     handleReplaceField();
    //   } else {
    //     showAlert(t("selectorenter"), "info");
    //   }
    // } else {
    //   showAlert(t("selectorenter"), "info");
    // }
    if (activeApprovedtabs.includes(t("Invertebrates")) || activeApprovedtabs.includes("Invertebrates")) {
      const existsFamilyDropdown = DropdownFamilyValues.some(
        item => item.value === speciesFamily
      );
      const existsSpeciesDropdown = DropdownSpeciesValues.some(
        item => item.value === speciesName
      );
      if (
        existsFamilyDropdown &&
        existsSpeciesDropdown
      ) {
        //handleReplaceField();
      }
      else {
        showAlert(t("selectorenter"), "info");
      }
    }
  };
  const handleEditCancel = () => {
    setEditingCardId(false);
    setcurrentClonedRow(null);
    if (isEditingCompleted == false) {
      resetFeatureData();
    }
  };
  const resetFeatureData = () => {
    data.current = data.current.map(
      (features) =>
        features.id === currentSelectedRow[0].id
          ? { ...currentSelectedRow[0] } // Reset the specific feature
          : features // Keep the other features unchanged
    );
  };

  const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= breakpoint);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
  };

  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) {
      if (fullView) {
        const fullContainer = document.querySelector('body');
        setWidgetMobEl(fullContainer);
      } else {
        const mobEl = document.getElementById('widgetMob');
        setWidgetMobEl(mobEl);
      }
    }
  }, [isMobile, fullView]);

  return (
    <>
      {activeApprovedtabs.includes(t("Invertebrates") || activeApprovedtabs.includes("Invertebrates")) && (
        <>
          {!editingCardId && (
            <div className="animalMobCardWrp mobileOnly">
              {invertebratesData &&
                invertebratesData.current.length > 0 &&
                invertebratesData.current.map((animal) => (
                  <div key={animal.id} className="animalMobCard">
                    <div className="aniMobCardHeader">
                      <h3>{animal.Species_Order}</h3>
                      <button
                        className="aniMobMenuButton"
                        onClick={() => toggleDropdown(animal.id)}
                      >
                        <HiMiniEllipsisVertical />
                      </button>

                      {isDropdownOpen === animal.id && (
                        <div className="aniMobMenu">
                          <ul>
                            <li onClick={() => toggleEdit(animal.id, "Edit")}>
                              <FiEdit2 className="me-2" />
                              {t("edit")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "Preview")}>
                              <FiEye className="me-2" />
                              {t("Preview")}
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="aniMobCardContent">
                      <div className="d-flex justify-content-between align-items-end">
                        <div>
                          <p>{animal.SpeciesFamily}</p>
                          <p className="mb-0">{animal.SpeciesName}</p>
                        </div>
                        <div className="aniMobTag">{animal.HabitatStatus}</div>
                      </div>
                      <div className="aniMobDetails">
                        <div className="aniMobDetailCard">
                          <p>{t("Location")}</p>
                          <p>{animal.LocationName}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Habitat")}</p>
                          <p>{animal.Habitat}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Observation Date")}</p>
                          <p>
                            {/* {new Date(animal.ObservationDate)
                              .toISOString()
                              .slice(0, 19)
                              .replace("T", " ")} */}
                            {animal.ObservationDate
                              ? new Date(animal.ObservationDate).toISOString().slice(0, 19).replace("T", " ")
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}

          {editingCardId && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setEditingCardId(false);
                    setcurrentClonedRow(null);
                    if (isEditingCompleted == false) {
                      resetFeatureData();
                    }
                  }}
                />
                <h5>{t("edit")}</h5>
              </div>
              {/* <div>
                                <div className="aniMobEditInputBlk">
                                    <label>Species Order</label>
                                    <Select
                                        options={speciesOrder}
                                        placeholder="Choose a species"
                                        isClearable
                                        className={`react-select-container`}
                                        classNamePrefix="react-select"
                                    />
                                </div>
                                <div className="aniMobEditInputBlk">
                                    <label>Family</label>
                                    <Select
                                        options={speciesOrder}
                                        placeholder="Choose a family"
                                        isClearable
                                        className={`react-select-container`}
                                        classNamePrefix="react-select"
                                    />
                                </div>
                                <div className="aniMobEditInputBlk">
                                    <label>Habitat</label>
                                    <Select
                                        options={speciesOrder}
                                        placeholder="Choose a habitat"
                                        isClearable
                                        className={`react-select-container`}
                                        classNamePrefix="react-select"
                                    />
                                </div>
                            </div> */}
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "SpeciesOrder" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.InvertiblesInfo.TargetFieldMapping.filter(
                      (attr) =>
                        attr.fieldname !== "id" &&
                        attr.fieldname !== "created_date" &&
                        attr.fieldname !== "Status" &&
                        attr.fieldname !== "DataSource" &&
                        attr.fieldname !== "GlobalID" &&
                        attr.fieldname !== "SpeciesOrder" &&
                        attr.fieldname === key
                    );
                    const formatKeyLabel = (key) => {
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }
                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };
                    return (
                      <div className="card-container" key={currentClonedRow.id}>
                        <div className="card-row" key={key}>
                          {currentClonedRow.id && filteredAttributes.length > 0 ? (
                            filteredAttributes[0].Domains === false ? (
                              key.includes("Date") ? (
                                <div>
                                  <label>{formatKeyLabel(key)}</label>
                                  <input className="form-control" type="text" defaultValue={new Date(currentClonedRow[key]).toISOString().slice(0, 19).replace('T', ' ')} style={{ pointerEvents: "none" }} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'text'); setEditingCardId(false); setcurrentClonedRow(null);}}  readOnly />
                                </div>
                              ) : (
                                <div>
                                  <label>{formatKeyLabel(key)}</label>
                                  <input className="form-control" type="text" defaultValue={currentClonedRow[key]} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'text'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                                </div>
                              )) : (
                              <div>
                                <label>{formatKeyLabel(key)}</label>
                                <input className="form-control" type="text" value={currentClonedRow[key]} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'domain'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                              </div>
                            )
                          ) : (
                            key.includes("Date") ? new Date(currentClonedRow[key]).toISOString().slice(0, 19).replace('T', ' ') : (
                              <div className="tableTxtTruncate">{currentClonedRow[key]}</div>
                            )
                          )}
                        </div>
                      </div>
                    );
                    // let InvertebratesdomainValues = [];

                    // if (key === "SpeciesFamily") {
                    //   // GetFamilyDropdown(currentClonedRow.InsectOrder);
                    //   InvertebratesdomainValues = DropdownFamilyValues;
                    // } else if (key === "SpeciesName") {
                    //   // GetSpeciesDropdown(currentClonedRow.Family);
                    //   InvertebratesdomainValues = DropdownSpeciesValues;
                    // } else {
                    //   const keyToUse = key === "Species_Order" ? "SpeciesOrder" : key;
                    //   InvertebratesdomainValues = domainValues[keyToUse] || [];
                    // }

                    // const formatKeyLabel = (key) => {
                    //   const fixedLabels = {
                    //     "point_x": "Point_X",
                    //     "point_y": "Point_Y",
                    //   };
                    //   const lowerKey = key.toLowerCase();
                    //   if (fixedLabels[lowerKey]) {
                    //     return fixedLabels[lowerKey];
                    //   }

                    //   return key
                    //     .replace(/_/g, ' ')                          // Replace underscores with spaces
                    //     .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                    //     .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    // };

                    // return (
                    //   <>
                    //     <div
                    //       className="card-container"
                    //       key={currentClonedRow.id}
                    //     >
                    //       <div className="card-row" key={key}>
                    //         {currentClonedRow.id &&
                    //           filteredAttributes.length > 0 ? (
                    //           filteredAttributes[0].Domains === false ? (
                    //             key === "ObservationDate" ||
                    //               key === "created_date" ? (
                    //               <div className="dateInputBlk">
                    //                 <label>{formatKeyLabel(key)}</label>
                    //                 <input
                    //                   type="datetime-local"
                    //                   className="form-control"
                    //                   value={
                    //                     currentClonedRow[currentClonedRow.id]?.[
                    //                       key
                    //                     ] !== undefined
                    //                       ? new Date([currentClonedRow.id][key])
                    //                         .toISOString()
                    //                         .slice(0, 19)
                    //                         .replace("T", " ")
                    //                       : new Date(currentClonedRow[key])
                    //                         .toISOString()
                    //                         .slice(0, 19)
                    //                         .replace("T", " ")
                    //                   }
                    //                   max={new Date()
                    //                     .toISOString()
                    //                     .slice(0, 16)} // Restrict future dates
                    //                   // onChange={
                    //                   //   (e) => {
                    //                   //     handleEditDropdownChange(e, key);
                    //                   //   }
                    //                   // }
                    //                   onClick={() => handleFieldClick(currentClonedRow.id, key, 'text')}
                    //                 />
                    //                 <RxCalendar />
                    //               </div>
                    //             ) : (
                    //               <>
                    //                 <div className="aniMobEditInputBlk">
                    //                   <label>{formatKeyLabel(key)}</label>
                    //                   <input
                    //                     type="text"
                    //                     value={
                    //                       currentClonedRow[
                    //                         currentClonedRow.id
                    //                       ]?.[key] !== undefined // Check if value is defined
                    //                         ? currentClonedRow[
                    //                         currentClonedRow.id
                    //                         ][key]
                    //                         : currentClonedRow[key]
                    //                     }
                    //                     className="form-control InputTextHolder"
                    //                     // onChange={(e) => {
                    //                     //   handleEditDropdownChange(e, key);
                    //                     // }}
                    //                     onClick={() => handleFieldClick(currentClonedRow.id, key, 'text')}
                    //                   />
                    //                 </div>
                    //               </>
                    //             )
                    //           ) : key === "Species_Order" ? (
                    //             <>
                    //               <label>{formatKeyLabel(key)}</label>
                    //               <Select
                    //                 options={InvertebratesdomainValues.map(
                    //                   (option) => ({
                    //                     value: option.key,
                    //                     label: option.value,
                    //                   })
                    //                 )}
                    //                 value={
                    //                   currentClonedRow?.[key]
                    //                     ? {
                    //                       value: InvertebratesdomainValues.find(
                    //                         (opt) => opt.value === currentClonedRow[key]
                    //                       )?.key || "",
                    //                       label: currentClonedRow[key],
                    //                     }
                    //                     : null
                    //                 }
                    //                 // value={
                    //                 //   currentClonedRow.SpeciesOrder
                    //                 //     ? InvertebratesdomainValues.find(
                    //                 //         (domain) =>
                    //                 //           domain.key ===
                    //                 //             currentClonedRow.SpeciesOrder ||
                    //                 //           domain.value ===
                    //                 //             currentClonedRow.SpeciesOrder
                    //                 //       )
                    //                 //       ? {
                    //                 //           value:
                    //                 //             currentClonedRow.SpeciesOrder,
                    //                 //           label: InvertebratesdomainValues.find(
                    //                 //             (domain) =>
                    //                 //               domain.key ===
                    //                 //                 currentClonedRow.SpeciesOrder ||
                    //                 //               domain.value ===
                    //                 //                 currentClonedRow.SpeciesOrder
                    //                 //           ).value,
                    //                 //         }
                    //                 //       : null
                    //                 //     : null
                    //                 // }
                    //                 // onChange={(e) => {

                    //                 //   handleEditDropdownChange(e, key);
                    //                 //   GetFamilyDropdown(e ? e.value : "");
                    //                 // }}
                    //                 onClick={() => handleFieldClick(currentClonedRow.id, key, 'domain')}
                    //                 components={{
                    //                   DropdownIndicator: CustomDropdownIndicator,
                    //                 }}
                    //                 className="react-select-container"
                    //                 classNamePrefix="react-select"
                    //                 placeholder={t("Select Insect Order")}
                    //                 required
                    //               />
                    //             </>
                    //           ) : key === "SpeciesFamily" ? (
                    //             <>
                    //               <label>{formatKeyLabel(key)}</label>
                    //               <Select
                    //                 options={InvertebratesdomainValues.map(
                    //                   (option) => ({
                    //                     value: option.key,
                    //                     label: option.value,
                    //                   })
                    //                 )}
                    //                 value={
                    //                   currentClonedRow.SpeciesFamily
                    //                     ? InvertebratesdomainValues.find(
                    //                       (domain) =>
                    //                         domain.key ===
                    //                         currentClonedRow.SpeciesFamily ||
                    //                         domain.value ===
                    //                         currentClonedRow.SpeciesFamily
                    //                     )
                    //                       ? {
                    //                         value:
                    //                           currentClonedRow.SpeciesFamily,
                    //                         label: InvertebratesdomainValues.find(
                    //                           (domain) =>
                    //                             domain.key ===
                    //                             currentClonedRow.SpeciesFamily ||
                    //                             domain.value ===
                    //                             currentClonedRow.SpeciesFamily
                    //                         ).value,
                    //                       }
                    //                       : null
                    //                     : null
                    //                 }
                    //                 // onChange={(selectedOption) => {
                    //                 //   handleEditDropdownChange(
                    //                 //     selectedOption,
                    //                 //     key
                    //                 //   );
                    //                 //   GetSpeciesDropdown(
                    //                 //     selectedOption
                    //                 //       ? selectedOption.value
                    //                 //       : ""
                    //                 //   );
                    //                 // }}
                    //                 onClick={() => handleFieldClick(currentClonedRow.id, key, 'domain')}
                    //                 components={{
                    //                   DropdownIndicator: CustomDropdownIndicator,
                    //                 }}
                    //                 className="react-select-container"
                    //                 classNamePrefix="react-select"
                    //                 placeholder={t("Select Family")}
                    //               />
                    //             </>
                    //           ) : (
                    //             <>
                    //               <label>{formatKeyLabel(key)}</label>
                    //               <Select
                    //                 options={InvertebratesdomainValues.map(
                    //                   (option) => ({
                    //                     value: option.key,
                    //                     label: option.value,
                    //                   })
                    //                 )}
                    //                 value={
                    //                   currentClonedRow[key]
                    //                     ? InvertebratesdomainValues.find(
                    //                       (domain) =>
                    //                         domain.value ===
                    //                         currentClonedRow[key]
                    //                     )
                    //                       ? {
                    //                         value: currentClonedRow[key],
                    //                         label: InvertebratesdomainValues.find(
                    //                           (domain) =>
                    //                             domain.value ===
                    //                             currentClonedRow[key]
                    //                         ).value,
                    //                       }
                    //                       : null
                    //                     : null
                    //                 }
                    //                 // onChange={(selectedOption) => {
                    //                 //   handleEditDropdownChange(
                    //                 //     selectedOption,
                    //                 //     key
                    //                 //   );
                    //                 // }}
                    //                 onClick={() => handleFieldClick(currentClonedRow.id, key, 'domain')}
                    //                 components={{
                    //                   DropdownIndicator: CustomDropdownIndicator,
                    //                 }}
                    //                 className="react-select-container"
                    //                 classNamePrefix="react-select"
                    //                 placeholder={`Select ${key}`}
                    //               />
                    //             </>
                    //           )
                    //         ) : (
                    //           <>
                    //             <div className="aniMobEditInputBlk">
                    //               <label>{formatKeyLabel(key)}</label>
                    //               <input
                    //                 type="text"
                    //                 value={currentClonedRow[key]}
                    //                 name={key}
                    //                 // onChange={(e) => {
                    //                 //   handleEditDropdownChange(e, key);
                    //                 // }}
                    //                 onClick={() => handleFieldClick(currentClonedRow.id, key, 'text')}
                    //                 className="form-control InputTextHolder"
                    //               />
                    //             </div>
                    //           </>
                    //         )}
                    //       </div>
                    //     </div>
                    //   </>
                    // );
                  })}
              </div>
              {/* <div className="historicalFoter d-flex gap-2 py-3 panelfooter">
                <Button variant="outline" onClick={handleEditCancel}>
                  {t("Cancel")}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                  {t("Save Changes")}
                </Button>
              </div> */}
            </div>, widgetMobEl
          )}

          {previewCardId && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setPreviewCardId(false);
                  }}
                />
                <h5>{t("Preview")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "SpeciesOrder" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.InvertiblesInfo.TargetFieldMapping.filter(
                      (attr) =>
                        attr.fieldname !== "id" &&
                        attr.fieldname !== "created_date" &&
                        attr.fieldname !== "Status" &&
                        attr.fieldname !== "DataSource" &&
                        attr.fieldname !== "GlobalID" &&
                        attr.fieldname !== "SpeciesOrder" &&
                        attr.fieldname === key
                    );
                    let InvertebratesdomainValues = [];

                    if (key === "SpeciesFamily") {
                      InvertebratesdomainValues = DropdownFamilyValues;
                    } else if (key === "SpeciesName") {
                      InvertebratesdomainValues = DropdownSpeciesValues;
                    } else {
                      const keyToUse = key === "Species_Order" ? "SpeciesOrder" : key;
                      InvertebratesdomainValues = domainValues[keyToUse] || [];
                    }
                    const formatKeyLabel = (key) => {
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }
                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };
                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "ObservationDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? new Date([currentClonedRow.id][key])
                                            .toISOString()
                                            .slice(0, 19)
                                            .replace("T", " ")
                                          : new Date(currentClonedRow[key])
                                            .toISOString()
                                            .slice(0, 19)
                                            .replace("T", " ")
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={
                                        (e) => {
                                          handleEditDropdownChange(e, key);
                                        }
                                      }
                                      disabled
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) => {
                                          handleEditDropdownChange(e, key);
                                        }}
                                        disabled
                                      />
                                    </div>
                                  </>
                                )
                              ) : key === "Species_Order" ? (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={InvertebratesdomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow?.[key]
                                        ? {
                                          value: InvertebratesdomainValues.find(
                                            (opt) => opt.value === currentClonedRow[key]
                                          )?.key || "",
                                          label: currentClonedRow[key],
                                        }
                                        : null
                                    }
                                    onChange={(e) => {
                                      handleEditDropdownChange(e, key);
                                      GetFamilyDropdown(e ? e.value : "");
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={t("Select Insect Order")}
                                    required
                                    isDisabled={true}
                                  />
                                </>
                              ) : key === "SpeciesFamily" ? (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={InvertebratesdomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow.SpeciesFamily
                                        ? InvertebratesdomainValues.find(
                                          (domain) =>
                                            domain.key ===
                                            currentClonedRow.SpeciesFamily ||
                                            domain.value ===
                                            currentClonedRow.SpeciesFamily
                                        )
                                          ? {
                                            value:
                                              currentClonedRow.SpeciesFamily,
                                            label: InvertebratesdomainValues.find(
                                              (domain) =>
                                                domain.key ===
                                                currentClonedRow.SpeciesFamily ||
                                                domain.value ===
                                                currentClonedRow.SpeciesFamily
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption,
                                        key
                                      );
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={t("Select Family")}
                                    isDisabled={true}
                                  />
                                </>
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={InvertebratesdomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? InvertebratesdomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow[key]
                                        )
                                          ? {
                                            value: currentClonedRow[key],
                                            label: InvertebratesdomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow[key]
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption,
                                        key
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                    isDisabled={true}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) => {
                                      handleEditDropdownChange(e, key);
                                    }}
                                    className="form-control InputTextHolder"
                                    disabled
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>, widgetMobEl
          )}
        </>
      )}

      {activeApprovedtabs.includes(t("Plants") || activeApprovedtabs.includes("Plants")) && (
        <>
          {!editingCardId && (
            <div className="animalMobCardWrp mobileOnly">
              {plantsData &&
                plantsData.current.length > 0 &&
                plantsData.current.map((plants) => (
                  <div key={plants.id} className="animalMobCard">
                    <div className="aniMobCardHeader">
                      <h3>{plants.LatinName}</h3>
                      <button
                        className="aniMobMenuButton"
                        onClick={() => toggleDropdown(plants.id)}
                      >
                        <HiMiniEllipsisVertical />
                      </button>

                      {isDropdownOpen === plants.id && (
                        <div className="aniMobMenu">
                          <ul>
                            <li onClick={() => toggleEdit(plants.id, "Edit")}>
                              <FiEdit2 className="me-2" />
                              {t("edit")}
                            </li>
                            <li onClick={() => toggleEdit(plants.id, "Preview")}>
                              <FaEye className="me-2" />
                              {t("Preview")}
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="aniMobCardContent">
                      <div className="d-flex justify-content-between align-items-end">
                        <div>
                          <p>{plants.Phenology}</p>
                          <p className="mb-0">{plants.GrazingSigns}</p>
                        </div>
                        <div className="aniMobTag">{plants.HabitatStatus}</div>
                      </div>
                      <div className="aniMobDetails">
                        <div className="aniMobDetailCard">
                          <p>{t("Location")}</p>
                          <p>{plants.Location}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Habitat")}</p>
                          <p>{plants.Habitat}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Survey Date")}</p>
                          <p>
                            {/* {new Date(plants.SurveyDate)
                              .toISOString()
                              .slice(0, 19)
                              .replace("T", " ")} */}
                            {plants.SurveyDate
                              ? new Date(plants.SurveyDate).toISOString().slice(0, 19).replace("T", " ")
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}

          {editingCardId && currentSelectedRow && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setEditingCardId(false);
                    setcurrentClonedRow(null);
                    if (isEditingCompleted == false) {
                      resetFeatureData();
                    }
                  }}
                />
                <h5>{t("edit")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.PlantInfo.TargetFieldMapping.filter(
                      (attr) => {
                        return (
                          attr.fieldname !== "id" &&
                          attr.fieldname !== "created_date" &&
                          attr.fieldname !== "Status" &&
                          attr.fieldname !== "DataSource" &&
                          attr.fieldname !== "GlobalID" &&
                          attr.fieldname === key
                        );
                      }
                    );
                    // let plantDomainValues = [];

                    // if (key === "LatinName") {
                    //   plantDomainValues = domainValues["PlantSpecies"] || [];
                    // } else {
                    //   plantDomainValues = domainValues[key] || [];
                    // }

                    const formatKeyLabel = (key) => {
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }

                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };

                    return (
                      <div className="card-container" key={currentClonedRow.id}>
                        <div className="card-row" key={key}>
                          {currentClonedRow.id && filteredAttributes.length > 0 ? (
                            filteredAttributes[0].Domains === false ? (
                              key.includes("Date") ? (
                                <div>
                                  <label>{formatKeyLabel(key)}</label>
                                  <input className="form-control" type="text" defaultValue={new Date(currentClonedRow[key]).toISOString().slice(0, 19).replace('T', ' ')} style={{ pointerEvents: "none" }} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'text'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                                </div>
                              ) : (
                                <div>
                                  <label>{formatKeyLabel(key)}</label>
                                  <input className="form-control" type="text" defaultValue={currentClonedRow[key]} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'text'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                                </div>
                              )) : (
                              <div>
                                <label>{formatKeyLabel(key)}</label>
                                <input className="form-control" type="text" value={currentClonedRow[key]} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'domain'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                              </div>
                            )
                          ) : (
                            key.includes("Date") ? new Date(currentClonedRow[key]).toISOString().slice(0, 19).replace('T', ' ') : (
                              <div className="tableTxtTruncate">{currentClonedRow[key]}</div>
                            )
                          )}
                        </div>
                      </div>
                    );


                    // return (
                    //   <>
                    //     <div
                    //       className="card-container"
                    //       key={currentClonedRow.id}
                    //     >
                    //       <div className="card-row" key={key}>
                    //         {currentClonedRow.id &&
                    //           filteredAttributes.length > 0 ? (
                    //           filteredAttributes[0].Domains === false ? (
                    //             key === "SurveyDate" ||
                    //               key === "created_date" ? (
                    //               <div className="dateInputBlk">
                    //                 <label>{formatKeyLabel(key)}</label>
                    //                 <input
                    //                   type="datetime-local"
                    //                   className="form-control"
                    //                   value={
                    //                     currentClonedRow[currentClonedRow.id]?.[
                    //                       key
                    //                     ] !== undefined
                    //                       ? new Date(
                    //                         currentClonedRow[
                    //                         currentClonedRow.id
                    //                         ][key]
                    //                       )
                    //                         .toISOString()
                    //                         .slice(0, 19)
                    //                         .replace("T", " ")
                    //                       : new Date(currentClonedRow[key])
                    //                         .toISOString()
                    //                         .slice(0, 19)
                    //                         .replace("T", " ")
                    //                   }
                    //                   max={new Date()
                    //                     .toISOString()
                    //                     .slice(0, 16)} // Restrict future dates
                    //                   onChange={(e) =>
                    //                     handleEditDropdownChange(e, key)
                    //                   }
                    //                 />
                    //                 <RxCalendar />
                    //               </div>
                    //             ) : (
                    //               <>
                    //                 <div className="aniMobEditInputBlk">
                    //                   <label>{formatKeyLabel(key)}</label>
                    //                   <input
                    //                     type="text"
                    //                     value={
                    //                       currentClonedRow[
                    //                         currentClonedRow.id
                    //                       ]?.[key] !== undefined // Check if value is defined
                    //                         ? currentClonedRow[
                    //                         currentClonedRow.id
                    //                         ][key]
                    //                         : currentClonedRow[key]
                    //                     }
                    //                     className="form-control InputTextHolder"
                    //                     onChange={(e) =>
                    //                       handleEditDropdownChange(e, key)
                    //                     }
                    //                   />
                    //                 </div>
                    //               </>
                    //             )
                    //           ) : (
                    //             <>
                    //               <label>{formatKeyLabel(key)}</label>
                    //               <Select
                    //                 options={plantDomainValues.map(
                    //                   (option) => ({
                    //                     value: option.key,
                    //                     label: option.value,
                    //                   })
                    //                 )}
                    //                 value={
                    //                   currentClonedRow[key]
                    //                     ? {
                    //                       value: currentClonedRow[key],
                    //                       label:
                    //                         plantDomainValues.find(
                    //                           (option) =>
                    //                             option.value ===
                    //                             currentClonedRow[key]
                    //                         )?.value || `Select ${key}`,
                    //                     }
                    //                     : null
                    //                 }
                    //                 onChange={(selectedOption) => {
                    //                   handleEditDropdownChange(
                    //                     selectedOption,
                    //                     key
                    //                   );
                    //                 }}
                    //                 components={{
                    //                   DropdownIndicator: CustomDropdownIndicator,
                    //                 }}
                    //                 className="react-select-container"
                    //                 classNamePrefix="react-select"
                    //                 placeholder={`Select ${key}`}
                    //               />
                    //             </>
                    //           )
                    //         ) : (
                    //           <>
                    //             <div className="aniMobEditInputBlk">
                    //               <label>{formatKeyLabel(key)}</label>
                    //               <input
                    //                 type="text"
                    //                 value={currentClonedRow[key]}
                    //                 name={key}
                    //                 onChange={(e) =>
                    //                   handleEditDropdownChange(e, key)
                    //                 }
                    //                 className="form-control InputTextHolder"
                    //               />
                    //             </div>
                    //           </>
                    //         )}
                    //       </div>
                    //     </div>
                    //   </>
                    // );
                  })}
              </div>
              {/* <div className="historicalFoter d-flex gap-2 py-3 panelfooter">
                <Button variant="outline" onClick={handleEditCancel}>
                  {t("Cancel")}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                  {t("Save Changes")}
                </Button>
              </div> */}
            </div>, widgetMobEl
          )}

          {previewCardId && currentSelectedRow && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setPreviewCardId(false);
                  }}
                />
                <h5>{t("Preview")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.PlantInfo.TargetFieldMapping.filter(
                      (attr) => {
                        return (
                          attr.fieldname !== "id" &&
                          attr.fieldname !== "created_date" &&
                          attr.fieldname !== "Status" &&
                          attr.fieldname !== "DataSource" &&
                          attr.fieldname !== "GlobalID" &&
                          attr.fieldname === key
                        );
                      }
                    );
                    let plantDomainValues = [];

                    if (key === "LatinName") {
                      plantDomainValues = domainValues["PlantSpecies"] || [];
                    } else {
                      plantDomainValues = domainValues[key] || [];
                    }
                    const formatKeyLabel = (key) => {
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }

                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };
                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "SurveyDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? new Date(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                            .toISOString()
                                            .slice(0, 19)
                                            .replace("T", " ")
                                          : new Date(currentClonedRow[key])
                                            .toISOString()
                                            .slice(0, 19)
                                            .replace("T", " ")
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(e, key)
                                      }
                                      disabled
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(e, key)
                                        }
                                        disabled
                                      />
                                    </div>
                                  </>
                                )
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={plantDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? {
                                          value: currentClonedRow[key],
                                          label:
                                            plantDomainValues.find(
                                              (option) =>
                                                option.value ===
                                                currentClonedRow[key]
                                            )?.value || `Select ${key}`,
                                        }
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption,
                                        key
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                    isDisabled={true}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(e, key)
                                    }
                                    className="form-control InputTextHolder"
                                    disabled
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>, widgetMobEl
          )}
        </>
      )}

      {activeApprovedtabs.includes(t("Mammals") || activeApprovedtabs.includes("Mammals")) && (
        <>
          {!editingCardId && (
            <div className="animalMobCardWrp mobileOnly">
              {mammalData &&
                mammalData.current.length > 0 &&
                mammalData.current.map((mammal) => (
                  <div key={mammal.id} className="animalMobCard">
                    <div className="aniMobCardHeader">
                      <h3>{mammal.SpeciesName}</h3>
                      <button
                        className="aniMobMenuButton"
                        onClick={() => toggleDropdown(mammal.id)}
                      >
                        <HiMiniEllipsisVertical />
                      </button>

                      {isDropdownOpen === mammal.id && (
                        <div className="aniMobMenu">
                          <ul>
                            <li onClick={() => toggleEdit(mammal.id, "Edit")}>
                              <FiEdit2 className="me-2" />
                              {t("edit")}
                            </li>
                            <li onClick={() => toggleEdit(mammal.id, "Preview")}>
                              <FaEye className="me-2" />
                              {t("Preview")}
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="aniMobCardContent">
                      <div className="d-flex justify-content-between align-items-end">
                        <div>
                          <p>{mammal.Status}</p>
                          <p className="mb-0">{mammal.CollectionMethod}</p>
                        </div>
                        <div className="aniMobTag">{mammal.SightingType}</div>
                      </div>
                      <div className="aniMobDetails">
                        <div className="aniMobDetailCard">
                          <p>{t("Location")}</p>
                          <p>{mammal.LocationName}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Habitat")}</p>
                          <p>{mammal.Habitat}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t('Survey Date')}</p>
                          <p>
                            {/* {new Date(mammal.SurveyDate)
                              .toISOString()
                              .slice(0, 19)
                              .replace("T", " ")} */}
                            {mammal.SurveyDate
                              ? new Date(mammal.SurveyDate).toISOString().slice(0, 19).replace("T", " ")
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
          {editingCardId && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setEditingCardId(false);
                    setcurrentClonedRow(null);
                    if (isEditingCompleted == false) {
                      resetFeatureData();
                    }
                  }}
                />
                <h5>{t("edit")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.MammalsInfo.TargetFieldMapping.filter(
                      (attr) =>
                        attr.fieldname !== "id" &&
                        attr.fieldname !== "created_date" &&
                        attr.fieldname !== "Status" &&
                        attr.fieldname !== "DataSource" &&
                        attr.fieldname !== "GlobalID" &&
                        attr.fieldname === key
                    );
                    // let mammalesDomainValues = [];                    
                    // mammalesDomainValues = domainValues[key] || [];

                    const formatKeyLabel = (key) => {
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }
                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };

                    return (
                      <div className="card-container" key={currentClonedRow.id}>
                        <div className="card-row" key={key}>
                          {currentClonedRow.id && filteredAttributes.length > 0 ? (
                            filteredAttributes[0].Domains === false ? (
                              key.includes("Date") ? (
                                <div>
                                  <label>{formatKeyLabel(key)}</label>
                                  <input className="form-control" type="text" defaultValue={new Date(currentClonedRow[key]).toISOString().slice(0, 19).replace('T', ' ')} style={{ pointerEvents: "none" }} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'text'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                                </div>
                              ) : (
                                <div>
                                  <label>{formatKeyLabel(key)}</label>
                                  <input className="form-control" type="text" defaultValue={currentClonedRow[key]} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'text'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                                </div>
                              )) : (
                              <div>
                                <label>{formatKeyLabel(key)}</label>
                                <input className="form-control" type="text" value={currentClonedRow[key]} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'domain'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                              </div>
                            )
                          ) : (
                            key.includes("Date") ? new Date(currentClonedRow[key]).toISOString().slice(0, 19).replace('T', ' ') : (
                              <div className="tableTxtTruncate">{currentClonedRow[key]}</div>
                            )
                          )}
                        </div>
                      </div>
                    );

                    // return (
                    //   <>
                    //     <div
                    //       className="card-container"
                    //       key={currentClonedRow.id}
                    //     >
                    //       <div className="card-row" key={key}>
                    //         {currentClonedRow.id &&
                    //           filteredAttributes.length > 0 ? (
                    //           filteredAttributes[0].Domains === false ? (
                    //             key === "SurveyDate" ||
                    //               key === "created_date" ? (
                    //               <div className="dateInputBlk">
                    //                 <label>{formatKeyLabel(key)}</label>
                    //                 <input
                    //                   type="datetime-local"
                    //                   className="form-control"
                    //                   value={
                    //                     currentClonedRow[currentClonedRow.id]?.[
                    //                       key
                    //                     ] !== undefined
                    //                       ? new Date(
                    //                         currentClonedRow[
                    //                         currentClonedRow.id
                    //                         ][key]
                    //                       )
                    //                         .toISOString()
                    //                         .slice(0, 19)
                    //                         .replace("T", " ")
                    //                       : new Date(currentClonedRow[key])
                    //                         .toISOString()
                    //                         .slice(0, 19)
                    //                         .replace("T", " ")
                    //                   }
                    //                   max={new Date()
                    //                     .toISOString()
                    //                     .slice(0, 16)} // Restrict future dates
                    //                   onChange={(e) =>
                    //                     handleEditDropdownChange(
                    //                       e.currentTarget.value,
                    //                       key
                    //                     )
                    //                   } // Handle datetime input change
                    //                 />
                    //                 <RxCalendar />
                    //               </div>
                    //             ) : (
                    //               <>
                    //                 <div className="aniMobEditInputBlk">
                    //                   <label>{formatKeyLabel(key)}</label>
                    //                   <input
                    //                     type="text"
                    //                     value={
                    //                       currentClonedRow[
                    //                         currentClonedRow.id
                    //                       ]?.[key] !== undefined // Check if value is defined
                    //                         ? currentClonedRow[
                    //                         currentClonedRow.id
                    //                         ][key]
                    //                         : currentClonedRow[key]
                    //                     }
                    //                     className="form-control InputTextHolder"
                    //                     onChange={(e) =>
                    //                       handleEditDropdownChange(e, key)
                    //                     }
                    //                   />
                    //                 </div>
                    //               </>
                    //             )
                    //           ) : (
                    //             <>
                    //               <label>{formatKeyLabel(key)}</label>
                    //               <Select
                    //                 options={mammalesDomainValues.map(
                    //                   (option) => ({
                    //                     value: option.key,
                    //                     label: option.value,
                    //                   })
                    //                 )}
                    //                 value={
                    //                   currentClonedRow[key]
                    //                     ? mammalesDomainValues.find(
                    //                       (domain) =>
                    //                         domain.value ===
                    //                         currentClonedRow[key]
                    //                     )
                    //                       ? {
                    //                         value: currentClonedRow[key],
                    //                         label: mammalesDomainValues.find(
                    //                           (domain) =>
                    //                             domain.value ===
                    //                             currentClonedRow[key]
                    //                         ).value,
                    //                       }
                    //                       : null
                    //                     : null
                    //                 }
                    //                 onChange={(selectedOption) => {
                    //                   handleEditDropdownChange(
                    //                     selectedOption,
                    //                     key
                    //                   );

                    //                   //GetSpeciesDropdown(selectedOption ? selectedOption : "")
                    //                 }}
                    //                 components={{
                    //                   DropdownIndicator: CustomDropdownIndicator,
                    //                 }}
                    //                 className="react-select-container"
                    //                 classNamePrefix="react-select"
                    //                 placeholder={`Select ${key}`}
                    //               />
                    //             </>
                    //           )
                    //         ) : (
                    //           <>
                    //             <div className="aniMobEditInputBlk">
                    //               <label>{formatKeyLabel(key)}</label>
                    //               <input
                    //                 type="text"
                    //                 value={currentClonedRow[key]}
                    //                 name={key}
                    //                 onChange={(e) =>
                    //                   handleEditDropdownChange(e, key)
                    //                 }
                    //                 className="form-control InputTextHolder"
                    //               />
                    //             </div>
                    //           </>
                    //         )}
                    //       </div>
                    //     </div>
                    //   </>
                    // );
                  })}
              </div>
              {/* <div className="historicalFoter d-flex gap-2 py-3 panelfooter">
                <Button variant="outline" onClick={handleEditCancel}>
                  {t("Cancel")}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                  {t("Save Changes")}
                </Button>
              </div> */}
            </div>, widgetMobEl
          )}

          {previewCardId && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setPreviewCardId(false);
                  }}
                />
                <h5>{t("Preview")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.MammalsInfo.TargetFieldMapping.filter(
                      (attr) =>
                        attr.fieldname !== "id" &&
                        attr.fieldname !== "created_date" &&
                        attr.fieldname !== "Status" &&
                        attr.fieldname !== "DataSource" &&
                        attr.fieldname !== "GlobalID" &&
                        attr.fieldname === key
                    );
                    let mammalesDomainValues = [];
                    mammalesDomainValues = domainValues[key] || [];

                    const formatKeyLabel = (key) => {
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }

                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };

                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "SurveyDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? new Date(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                            .toISOString()
                                            .slice(0, 19)
                                            .replace("T", " ")
                                          : new Date(currentClonedRow[key])
                                            .toISOString()
                                            .slice(0, 19)
                                            .replace("T", " ")
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(
                                          e.currentTarget.value,
                                          key
                                        )
                                      }
                                      disabled
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(e, key)
                                        }
                                        disabled
                                      />
                                    </div>
                                  </>
                                )
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={mammalesDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? mammalesDomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow[key]
                                        )
                                          ? {
                                            value: currentClonedRow[key],
                                            label: mammalesDomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow[key]
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption,
                                        key
                                      );

                                      //GetSpeciesDropdown(selectedOption ? selectedOption : "")
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                    isDisabled={true}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(e, key)
                                    }
                                    className="form-control InputTextHolder"
                                    disabled
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>, widgetMobEl
          )}
        </>
      )}

      {activeApprovedtabs.includes(t("Reptiles") || activeApprovedtabs.includes("Reptiles")) && (
        <>
          {!editingCardId && (
            <div className="animalMobCardWrp mobileOnly">
              {reptilesData &&
                reptilesData.current.length > 0 &&
                reptilesData.current.map((reptile) => (
                  <div key={reptile.id} className="animalMobCard">
                    <div className="aniMobCardHeader">
                      <h3>{reptile.SpeciesName}</h3>
                      <button
                        className="aniMobMenuButton"
                        onClick={() => toggleDropdown(reptile.id)}
                      >
                        <HiMiniEllipsisVertical />
                      </button>

                      {isDropdownOpen === reptile.id && (
                        <div className="aniMobMenu">
                          <ul>
                            <li onClick={() => toggleEdit(reptile.id, "Edit")}>
                              <FiEdit2 className="me-2" />
                              {t("edit")}
                            </li>
                            <li onClick={() => toggleEdit(reptile.id, "Preview")}>
                              <FaEye className="me-2" />
                              {t("Preview")}
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="aniMobCardContent">
                      <div className="d-flex justify-content-between align-items-end">
                        <div>
                          <p>{reptile.SightingType}</p>
                          <p className="mb-0">{reptile.Reptiles}</p>
                        </div>
                        <div className="aniMobTag">{reptile.Status}</div>
                      </div>
                      <div className="aniMobDetails">
                        <div className="aniMobDetailCard">
                          <p>{t("Micro Habitat")}</p>
                          <p>{reptile.MicroHabitat}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Habitat")}</p>
                          <p>{reptile.Habitat}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Observation Date")}</p>
                          <p>
                            {/* {new Date(reptile.ObservationDate)
                              .toISOString()
                              .slice(0, 19)
                              .replace("T", " ")} */}
                            {reptile.ObservationDate
                              ? new Date(reptile.ObservationDate).toISOString().slice(0, 19).replace("T", " ")
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}

          {editingCardId && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setEditingCardId(false);
                    setcurrentClonedRow(null);
                    if (isEditingCompleted == false) {
                      resetFeatureData();
                    }
                  }}
                />
                <h5>{t("edit")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.ReptilesInfo.TargetFieldMapping.filter(
                      (attr) =>
                        attr.fieldname !== "id" &&
                        attr.fieldname !== "created_date" &&
                        attr.fieldname !== "Status" &&
                        attr.fieldname !== "DataSource" &&
                        attr.fieldname !== "GlobalID" &&
                        attr.fieldname === key
                    );
                    // let reptilsDomainValues = [];
                    // const keyToUse = key === "SpeciesName" ? "Species" : key;
                    // reptilsDomainValues = domainValues[keyToUse] || [];

                    const formatKeyLabel = (key) => {
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }

                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };
                    return (
                      <div className="card-container" key={currentClonedRow.id}>
                        <div className="card-row" key={key}>
                          {currentClonedRow.id && filteredAttributes.length > 0 ? (
                            filteredAttributes[0].Domains === false ? (
                              key.includes("Date") ? (
                                <div>
                                  <label>{formatKeyLabel(key)}</label>
                                  <input className="form-control" type="text" defaultValue={new Date(currentClonedRow[key]).toISOString().slice(0, 19).replace('T', ' ')} style={{ pointerEvents: "none" }} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'text'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                                </div>
                              ) : (
                                <div>
                                  <label>{formatKeyLabel(key)}</label>
                                  <input className="form-control" type="text" defaultValue={currentClonedRow[key]} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'text'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                                </div>
                              )) : (
                              <div>
                                <label>{formatKeyLabel(key)}</label>
                                <input className="form-control" type="text" value={currentClonedRow[key]} onClick={() => {handleFieldClick(currentClonedRow.id, key, 'domain'); setEditingCardId(false); setcurrentClonedRow(null);}} readOnly />
                              </div>
                            )
                          ) : (
                            key.includes("Date") ? new Date(currentClonedRow[key]).toISOString().slice(0, 19).replace('T', ' ') : (
                              <div className="tableTxtTruncate">{currentClonedRow[key]}</div>
                            )
                          )}
                        </div>
                      </div>
                    );

                    // return (
                    //   <>
                    //     <div
                    //       className="card-container"
                    //       key={currentClonedRow.id}
                    //     >
                    //       <div className="card-row" key={key}>
                    //         {currentClonedRow.id &&
                    //           filteredAttributes.length > 0 ? (
                    //           filteredAttributes[0].Domains === false ? (
                    //             key === "ObservationDate" ||
                    //               key === "created_date" ? (
                    //               <div className="dateInputBlk">
                    //                 <label>{formatKeyLabel(key)}</label>
                    //                 <input
                    //                   type="datetime-local"
                    //                   className="form-control"
                    //                   value={
                    //                     currentClonedRow[currentClonedRow.id]?.[
                    //                       key
                    //                     ] !== undefined
                    //                       ? new Date(
                    //                         currentClonedRow[
                    //                         currentClonedRow.id
                    //                         ][key]
                    //                       )
                    //                         .toISOString()
                    //                         .slice(0, 19)
                    //                         .replace("T", " ")
                    //                       : new Date(currentClonedRow[key])
                    //                         .toISOString()
                    //                         .slice(0, 19)
                    //                         .replace("T", " ")
                    //                   }
                    //                   max={new Date()
                    //                     .toISOString()
                    //                     .slice(0, 16)} // Restrict future dates
                    //                   onChange={(e) =>
                    //                     handleEditDropdownChange(e, key)
                    //                   } // Handle datetime input change
                    //                 />
                    //                 <RxCalendar />
                    //               </div>
                    //             ) : (
                    //               <>
                    //                 <div className="aniMobEditInputBlk">
                    //                   <label>{formatKeyLabel(key)}</label>
                    //                   <input
                    //                     type="text"
                    //                     value={
                    //                       currentClonedRow[
                    //                         currentClonedRow.id
                    //                       ]?.[key] !== undefined // Check if value is defined
                    //                         ? currentClonedRow[
                    //                         currentClonedRow.id
                    //                         ][key]
                    //                         : currentClonedRow[key]
                    //                     }
                    //                     className="form-control InputTextHolder"
                    //                     onChange={(e) =>
                    //                       handleEditDropdownChange(e, key)
                    //                     }
                    //                   />
                    //                 </div>
                    //               </>
                    //             )
                    //           ) : (
                    //             <>
                    //               <label>{formatKeyLabel(key)}</label>
                    //               <Select
                    //                 options={reptilsDomainValues.map(
                    //                   (option) => ({
                    //                     value: option.key,
                    //                     label: option.value,
                    //                   })
                    //                 )}
                    //                 value={
                    //                   currentClonedRow[key]
                    //                     ? reptilsDomainValues.find(
                    //                       (domain) =>
                    //                         domain.value ===
                    //                         currentClonedRow[key]
                    //                     )
                    //                       ? {
                    //                         value: currentClonedRow[key],
                    //                         label: reptilsDomainValues.find(
                    //                           (domain) =>
                    //                             domain.value ===
                    //                             currentClonedRow[key]
                    //                         ).value,
                    //                       }
                    //                       : null
                    //                     : null
                    //                 }
                    //                 onChange={(selectedOption) => {
                    //                   handleEditDropdownChange(
                    //                     selectedOption,
                    //                     key
                    //                   );
                    //                   // GetSpeciesDropdown(selectedOption ? selectedOption.label : "")
                    //                 }}
                    //                 components={{
                    //                   DropdownIndicator: CustomDropdownIndicator,
                    //                 }}
                    //                 className="react-select-container"
                    //                 classNamePrefix="react-select"
                    //                 placeholder={`Select ${key}`}
                    //               />
                    //             </>
                    //           )
                    //         ) : (
                    //           <>
                    //             <div className="aniMobEditInputBlk">
                    //               <label>{formatKeyLabel(key)}</label>
                    //               <input
                    //                 type="text"
                    //                 value={currentClonedRow[key]}
                    //                 name={key}
                    //                 onChange={(e) =>
                    //                   handleEditDropdownChange(e, key)
                    //                 }
                    //                 className="form-control InputTextHolder"
                    //               />
                    //             </div>
                    //           </>
                    //         )}
                    //       </div>
                    //     </div>
                    //   </>
                    // );
                  })}
              </div>
              {/* <div className="historicalFoter d-flex gap-2 py-3 panelfooter">
                <Button variant="outline" onClick={handleEditCancel}>
                  {t("Cancel")}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                  {t("Save Changes")}
                </Button>
              </div> */}
            </div>, widgetMobEl
          )}

          {previewCardId && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setPreviewCardId(false);
                  }}
                />
                <h5>{t("Preview")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.ReptilesInfo.TargetFieldMapping.filter(
                      (attr) =>
                        attr.fieldname !== "id" &&
                        attr.fieldname !== "created_date" &&
                        attr.fieldname !== "Status" &&
                        attr.fieldname !== "DataSource" &&
                        attr.fieldname !== "GlobalID" &&
                        attr.fieldname === key
                    );
                    let reptilsDomainValues = [];
                    const keyToUse = key === "SpeciesName" ? "Species" : key;
                    reptilsDomainValues = domainValues[keyToUse] || [];

                    const formatKeyLabel = (key) => {
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }

                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };


                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "ObservationDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? new Date(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                            .toISOString()
                                            .slice(0, 19)
                                            .replace("T", " ")
                                          : new Date(currentClonedRow[key])
                                            .toISOString()
                                            .slice(0, 19)
                                            .replace("T", " ")
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(e, key)
                                      } // Handle datetime input change
                                      disabled
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(e, key)
                                        }
                                        disabled
                                      />
                                    </div>
                                  </>
                                )
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={reptilsDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? reptilsDomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow[key]
                                        )
                                          ? {
                                            value: currentClonedRow[key],
                                            label: reptilsDomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow[key]
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption,
                                        key
                                      );
                                      // GetSpeciesDropdown(selectedOption ? selectedOption.label : "")
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                    isDisabled={true}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(e, key)
                                    }
                                    className="form-control InputTextHolder"
                                    disabled
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>, widgetMobEl
          )}
        </>
      )}
    </>
  );
};

export default AnimalSightingMobileApproved;
